import api from "./axios";

export const adminGetUsers = () => api.get("/api/admin/users/");
export const adminCreateUser = (data) => api.post("/api/admin/users/", data);
export const adminUpdateUser = (id, data) => api.put(`/api/admin/users/${id}/`, data);
export const adminDeleteUser = (id) => api.delete(`/api/admin/users/${id}/`);
export const adminGetUser = (id) => api.get(`/api/admin/users/${id}/`);